import { GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import { NoInfer } from "../Utils/utilityTypes";

export const columnForField = <T,>(
  field: keyof NoInfer<T> & string,
  props?: GridColumnProps & { hideFilterCell?: boolean }
) => (
  <GridColumn
    key={field}
    editable={false}
    field={field}
    title={props?.title || field}
    filter={props?.filter || "text"}
    minResizableWidth={50}
    filterCell={props?.hideFilterCell ? () => null : undefined} // undefined renders the default filter cell
    {...props}
  />
);

export const defaultColumnWidth = "175px";
